import { Box, Container, Grid } from "@mui/material";
import React from "react";
import CoreDataTable from "../../core/dataDisplay/datatable/CoreDataTable";
import CoreDatePicker from "../../core/inputs/CoreDatePicker";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import moment from "moment";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_GET } from "../../config/constants";
import {
  FETCH_USAGE_ERROR,
  FETCH_USAGE_SUCCESS,
} from "../../store/types/billTypes";
import CoreTypographyBody1 from "../../core/dataDisplay/CoreTypographyBody1";

export default function Usage() {
  const dispatch = useDispatch();

  const [startDate, setStartDate] = useState(
    moment().subtract(5, "days").format("DD-MM-YYYY"),
  );
  const [endDate, setEndDate] = useState(moment().format("DD-MM-YYYY"));

  const usage = useSelector((state) => state.bill.usage);

  useEffect(() => {
    getUsage();
  }, []);

  const getUsage = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/check/usage/list",
        {},
        {
          startDate: moment(startDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
          endDate: moment(endDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
        },
        null,
        FETCH_USAGE_SUCCESS,
        FETCH_USAGE_ERROR,
        true,
        false,
      ),
    );
  };

  const allDocs = usage?.usage;
  const count = usage?.count;

  return (
    <Container>
      <Box style={{ marginTop: 16 }}>
        <Grid container spacing={2}>
          <Grid xs={12} sm={4} item>
            <CoreDatePicker
              value={startDate}
              onChange={(val) => setStartDate(val)}
              label="Start Date"
            />
          </Grid>
          <Grid xs={12} sm={4} item>
            <CoreDatePicker
              value={endDate}
              onChange={(val) => setEndDate(val)}
              label="End Date"
            />
          </Grid>
          <Grid xs={12} sm={4} item>
            <CoreContainedButton onClick={getUsage}>
              Get Usage
            </CoreContainedButton>
          </Grid>
        </Grid>
      </Box>
      <Box style={{ marginTop: 16 }}>
        <CoreTypographyBody1>
          Total Count: <strong>{count}</strong>
        </CoreTypographyBody1>
      </Box>
      <Box>
        <CoreDataTable
          selectable={false}
          showToolbar={false}
          columns={[
            {
              view: (row) => {
                return row.originalFileName;
              },
              name: "originalFileName",
              label: "File Name",
              width: "130px",
            },
            {
              view: (row) => {
                return row.type;
              },
              name: "Document type",
              label: "type",
              width: "130px",
            },
            {
              view: (row) => {
                return row.noOfPages;
              },
              label: "No of pages",
              name: "noOfPages",
              width: "130px",
            },
            {
              view: (row) => {
                return row.creditUsed;
              },
              name: "creditUsed",
              label: "Credit used",
              width: "130px",
            },
            {
              view: (row) => {
                return row.createdAt;
              },
              name: "createdAt",
              label: "Uploaded on",
              width: "130px",
            },
          ]}
          dataRows={allDocs || []}
        />
      </Box>
    </Container>
  );
}
